import * as React from "react";
import Papers from "./papers";
import { academicLinksData, publicationData } from "../data";
import { useLang } from "../lang";

const Publication: React.FC = () => {
  const { langEn } = useLang();
  const publications = publicationData.publications ?? [];
  const papers = publications
    .filter(
      (item) => item.kind !== "patent" && item.kind !== "book" && item.kind !== "dissertation"
    )
    .sort((a, b) => {
      const ap = a.priority ?? 0;
      const bp = b.priority ?? 0;
      if (ap !== bp) return bp - ap;
      if (a.year !== b.year) return (b.year ?? 0) - (a.year ?? 0);
      if (a.month !== b.month) return (b.month ?? 0) - (a.month ?? 0);
      return 0;
    });

  const books = publications.filter((item) => item.kind === "book");
  const dissertations = publications.filter((item) => item.kind === "dissertation");

  return (
    <div id="publication" className="container justify-content-center">
      <p className="title mb-2">
        <span className="mr-2">{langEn ? "Publication" : "業績"}</span>
        <br className="d-block d-sm-none" />
        {academicLinksData.map((item, i) => (
          <a
            key={"academic-link" + i}
            href={item.url}
            data-toggle="tooltip"
            data-placement="top"
            title={item.name}
            className={"academic-icon ai ai-" + item.icon + "-square"}
          ></a>
        ))}
      </p>

      <div className="row">
        <Papers items={papers} title_en="" title_ja="" show_num comment="journal: ★" />

        <Papers items={dissertations} title_en="Ph.D. Dissertation" title_ja="博士論文" />

        <Papers items={books} title_en="Book" title_ja="本" />
      </div>
    </div>
  );
};

export default Publication;
